<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document" :style="isLinkTypeAllowedToEdit?'height:400px':'height:450px'">
            <div class="modal-content">
                <div class="modal-header p-2">
                    <h6 class="modal-title">{{isLinkTypeAllowedToEdit?$t("Edit"):$t("Add")}}</h6>
                    <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">
                            <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                        </span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="project-fields-wrapper">
                        <div class="comm-project-fields" :class="isLinkTypeAllowedToEdit?'edit-border-field':''">
                            <label class="input-field-label">{{$t("Link Name")}} *</label>
                            <template v-if="!isEditable('link_name') && Object.keys(dataToPopulate).length>0">
                                <span class="task-data-value"> {{dataToPopulate.link_name}}</span>
                                <edit-icon @click.native="editLinkTypeFields('link_name')" class="editIcon"></edit-icon>
                            </template>
                            <template v-else-if="isEditable('link_name')">
                                <div class="input-field-value-div">
                                   <input ref="linkName" v-model="linkName" type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" :style="isLinkTypeAllowedToEdit?'width:85%':'width:100%'" style="float:inline-start;">
                                    <div v-if="isLinkTypeAllowedToEdit" class="d-flex" style="height: 40px;align-items: center;">
                                        <save-icon @click.native="linkTypeFieldUpdateRequest('link_name')"></save-icon>
                                        <cancel-icon @click.native="cancelProjectFieldsEdit('link_name')"></cancel-icon>
                                    </div>
                                </div>
                            </template>    
                        </div>
                        <div class="comm-project-fields" :class="isLinkTypeAllowedToEdit?'edit-border-field':''">
                            <label class="input-field-label">{{$t("Outward Description")}} *</label>
                            <template v-if="!isEditable('outward_desc') && Object.keys(dataToPopulate).length>0">
                                <span class="task-data-value"> {{dataToPopulate.outward_desc}}</span>
                                <edit-icon @click.native="editLinkTypeFields('outward_desc')" class="editIcon"></edit-icon>
                            </template>
                            <template v-else-if="isEditable('outward_desc')">
                                <div class="input-field-value-div">
                                   <textarea ref="linkName" v-model="linkOutwardDecription" type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" :style="isLinkTypeAllowedToEdit?'width:85%':'width:100%'" style="float:inline-start;max-height:200px;min-height:40px;"></textarea>
                                    <div v-if="isLinkTypeAllowedToEdit" class="d-flex" style="height: 40px;align-items: center;">
                                        <save-icon @click.native="linkTypeFieldUpdateRequest('outward_desc')"></save-icon>
                                        <cancel-icon @click.native="cancelProjectFieldsEdit('outward_desc')"></cancel-icon>
                                    </div>
                                </div>
                            </template>    
                        </div>
                        <div class="comm-project-fields" :class="isLinkTypeAllowedToEdit?'edit-border-field':''">
                            <label class="input-field-label">{{$t('Inward Description')}} *</label>
                            <template v-if="!isEditable('inward_desc') && Object.keys(dataToPopulate).length>0">
                                <span class="task-data-value"> {{dataToPopulate.inward_desc}}</span>
                                <edit-icon @click.native="editLinkTypeFields('inward_desc')" class="editIcon"></edit-icon>
                            </template>
                            <template v-else-if="isEditable('inward_desc')">
                                <div class="input-field-value-div">
                                   <textarea ref="linkName" v-model="linkInwardDescription" type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" :style="isLinkTypeAllowedToEdit?'width:85%':'width:100%'" style="float:inline-start;max-height:200px;min-height:40px;"></textarea>
                                    <div v-if="isLinkTypeAllowedToEdit" class="d-flex" style="height: 40px;align-items: center;">
                                        <save-icon @click.native="linkTypeFieldUpdateRequest('inward_desc')"></save-icon>
                                        <cancel-icon @click.native="cancelProjectFieldsEdit('inward_desc')"></cancel-icon>
                                    </div>
                                </div>
                            </template>    
                        </div>
                    </div>  
                </div>
                <div class="modal-footer p-0 primary-btn-style">
                    <button class="btn btn-outline-secondary" data-dismiss="modal" @click="closeModal"> {{$t('Cancel')}} </button>
                    <button v-if="!isLinkTypeAllowedToEdit" class="btn btn-outline-primary mr-2" @click='addNewLinkType()'>{{$t('Save')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>  

<script>
    import {mapActions} from "vuex";
    import Utils from "../../components.utils.js"   
    import EditIcon from "../core/InlineEditField.vue";
    import SaveIcon from "../core/InlineSaveField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";

    export default {
        props:["dataToPopulate", "isLinkTypeAllowedToEdit"],
        data() {
            return{
                linkName:"",
                linkOutwardDecription:"",
                linkInwardDescription:"",
                editingKeyName:null,
            }
        },

        components:{
            'cancel-icon':CancelIcon,
            "edit-icon":EditIcon,
            "save-icon":SaveIcon,
        },

        methods:{
            isEditable(keyname){
                if(this.isLinkTypeAllowedToEdit){
                    return keyname === this.editingKeyName;
                }
                return true;
            },

            closeModal(){
                this.$emit("closeModal", true);
            },

            editLinkTypeFields(fieldName, fieldValue){
                console.log(fieldValue)
                this.editingKeyName = fieldName;
                if(fieldName == "link_name"){
                    this.linkName = this.dataToPopulate.link_name;
                }
                if(fieldName == "outward_desc"){
                    this.linkOutwardDecription = this.dataToPopulate.outward_desc;
                }
                if(fieldName == "inward_desc"){
                    this.linkInwardDescription = this.dataToPopulate.inward_desc;
                }
            }, 

            cancelProjectFieldsEdit(fieldName){
                this.editingKeyName = null;
                if(fieldName == "link_name"){
                    this.linkName = this.dataToPopulate.link_name;
                }
                if(fieldName == "outward_desc"){
                    this.linkOutwardDecription = this.dataToPopulate.outward_desc;
                }
                if(fieldName == "inward_desc"){
                    this.linkInwardDescription = this.dataToPopulate.inward_desc;
                }
            },

            addNewLinkType(){
                if(!this.linkName || (this.linkName.trim().length <= 0)){
                    alert("Empty Link Name");
                    return false;
                }

                if(!this.linkOutwardDecription || (this.linkOutwardDecription.trim().length <= 0)){
                    alert(this.$t("Empty Outward Description"));
                    return false;
                }

                if(!this.linkInwardDescription || (this.linkInwardDescription.trim().length <= 0)){
                    alert(this.$t("Empty Inward Description"));
                    return false;
                }
                let payload = {link_name: this.linkName.trim(), outward_desc:this.linkOutwardDecription.trim(), inward_desc:this.linkInwardDescription.trim()};
                this.addAssetLinkType(payload).then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if(data.message) this.$toast.success(data.message);
                        this.$emit("closeModal", true);
                        this.$emit("updatelinkTypeList", data.upserted_data);
                    } else {
                        if(data.message) this.$toast.error(data.message);  
                    }
                });

            },

            linkTypeFieldUpdateRequest(field){
                let payload={_id:this.dataToPopulate._id, params:{}};
                if(field == "link_name"){
                    if(!this.linkName || (this.linkName.trim().length <= 0)){
                        alert("Empty Link Name");
                        return false;
                    }
                    payload["link_name"] = this.linkName.trim();
                }
                if(field == "outward_desc"){
                    if(!this.linkOutwardDecription || (this.linkOutwardDecription.trim().length <= 0)){
                        alert("Empty Outward Description");
                        return false;
                    }
                    payload["outward_desc"] = this.linkOutwardDecription.trim();
                }
                if(field == "inward_desc"){
                    if(!this.linkInwardDescription || (this.linkInwardDescription.trim().length <= 0)){
                        alert("Empty Inward Description");
                        return false;
                    }
                    payload["inward_desc"] = this.linkInwardDescription.trim();
                }

                this.updateAssetLinkType(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)){
                        if(data.message){
                            this.$toast.success(data.message);
                            // this.$emit("closeModal", true);
                            this.editingKeyName = null;
                            this.dataToPopulate[field] = data.modified_data[field];
                            this.dataToPopulate["modified_datetime"] = data.modified_data["modified_datetime"];
                        }else{
                            this.$toast.success("Successfully Updated")
                        }  
                    } else {
                        if(data.message) this.$toast.error(data.message);
                    }
                });
            },
            ...mapActions("assets", ["addAssetLinkType", "updateAssetLinkType"]),
        }
    }        

</script>

<style lang="scss" scoped>
    $header-background: #1a1a1a; //header bar background color (eg. Top nav)
    // $border-color: 1px solid #1a1a1a;
    $secondary-border-color: 1px solid #3a3a3a;
    $searchBar-border-color: 1px solid #202020;
    $background: #121212; //background color
    $background-color-on-hover: #141414;
    $body-background-color: #0d0d0d !important;; //Application background color
    $text-color: #eee;
    $dull-text-color: #757575;
    // $secondary-text-color: #bbb;
    $table-row-border: none;
    $active-blue : #007bff;
    $modal-border:1px solid #202020;
    $modal-background: #0a0a0a;
    $header-color:#9e9e9e; //Color of the header's title or nav bar labels

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $secondary-text-color: #9c9c9c;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #4a4a4a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $icon-hover:#2c3339;
    $input-field-border-color:1px solid #3a3a3a;

    .modal-dialog {
        max-width: 500px !important;
        width: 500px !important;
        // height: 60% !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: 130px;
            overflow: auto;
            padding: 1rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        position: fixed;
        align-items: center;
        justify-content: center;
        
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:14px !important;
        height:100%;
    }


    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start: 0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height:45px;
        .modal-title{
            color:$text-color;
            padding: 2%;
            // height:45px;
            line-height: 4px;
        }
    }

    .modal-header .close {
        margin:0px !important;
        padding: 0px !important;
    }
    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
    }
    ul{
        list-style-type: none;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .comm-project-fields{
        width: 100%;
        // display: inline-flex;
        margin-bottom: 10px;
        display: inline-block;
        // width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background:$primary-background;
        border: $secondary-border-color !important;
        label{
            margin-bottom: 3px;
            width: 100%;
            text-align: start;
            padding-inline-end: 10px;
            color: $secondary-text-color;
        }
        .input-field-value-div{
            width: 100%;
            display: inline-block;
        }
    }

    .comm-checkbox-field{
        height:30px;
        display: inline-block;
        padding-inline-start:8%;
        .input-field-label{
            display: inline-flex;
            height:100%;
            align-items: center;
        }
    }

    .comm-input-field-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .comm-input-label{
        display:inline-block;
        width:100%;
        margin:20px 10px;
        width:80%;
    }

    .primary-btn-style{
        margin-top:1%;
        justify-content: flex-end;
        button{
            height: 35px;
            width: 70px;
        font-size:14px;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }
    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .comm-project-fields:hover{
        .editIcon{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }

    .editIcon{
        visibility: hidden;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
</style>